$(document).ready(function() {
	$('.popup-with-zoom-anim').magnificPopup({
		type: 'inline',
		fixedContentPos: false,
		fixedBgPos: true,
		overflowY: 'auto',
		closeBtnInside: true,
        closeOnBgClick: false,
		preloader: false,
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in'
	});
});

$(document).ready(function () {
 setTimeout(function() {
   if ($('#question-popup').length) {
     $.magnificPopup.open({
      items: {
          src: '#question-popup' 
      },
      type: 'inline'
     });
   }
 }, 10000);
  
  $('#question-popup .btn').click(function(){
    $.magnificPopup.close();
    $("#shopify-chat iframe").contents().find(".chat-toggle").click();
  });
  
  setTimeout(function() {
  $(".bold-ro__bold-active").append("Delivered every 30 days. Cancel anytime.");
  }, 1000);
});
